import React from "react";
import { _OrderAccordionRoot } from "./OrderAccordion.styled";
import OrderAccordionItem from "./OrderAccordionItem/OrderAccordionItem";

export interface IOrderProduct {
  id: string;
  name: string;
  image: string;
  price: number | string;
}

export interface IOrderAccordion {
  id: string;
  totalPrice: number | string;
  formattedDate: string;
  shortFormattedDate: string;
  products: IOrderProduct[];
  onClick?: () => Promise<void> | void;
  formattedQuantity?: string;
}

export interface IOrderAccordionProps {
  list: IOrderAccordion[];
  onReorder?: (order: IOrderAccordion) => void;
  reorderLabel?: React.ReactNode;
  deleteLabel?: string;
}

const OrderAccordion = (props: IOrderAccordionProps) => {
  const { list = [], onReorder, reorderLabel, deleteLabel } = props;

  return (
    <_OrderAccordionRoot>
      {list.map((order, index) => {
        return (
          <OrderAccordionItem
            {...{
              key: index,
              order,
              onReorder,
              reorderLabel,
              deleteLabel,
            }}
          />
        );
      })}
    </_OrderAccordionRoot>
  );
};

export default OrderAccordion;
